<script>
export default {
  inheritAttrs: false,
  model: {
    event: 'update',
  },
  props: {
    type: {
      type: String,
      default: 'text',
    },
    value: {
      type: [String, Number],
      default: '',
    },
    label: {
      type: String,
      default: '',
    },
  },
  computed: {
    addOnInput() {
      return {
        ...this.$attrs,
        onInput: (event) => {
          this.$emit('update', event.target.value)
          this.$emit('input', event)
        },
      }
    },
  },
}
</script>

<template>
  <label :class="$style.container">
    <div :class="$style.label">{{ label }}</div>
    <input
      ref="input"
      v-bind="addOnInput"
      :type="type"
      :value="value"
      :class="$style.input"
    />
  </label>
</template>

<style lang="scss" module>
@import '@design';

.container {
  display: block;
  margin-bottom: $size-grid-padding;
}

.label {
  @extend %typography-label;

  color: $color-input-label;
}

.input {
  @extend %typography-small;

  display: block;
  width: 100%;
  height: 34px;
  padding: $size-input-padding-vertical $size-input-padding-horizontal;
  margin: 0;
  line-height: 1;
  border: $size-input-border solid $color-input-border;
  border-radius: $size-input-border-radius;
  -webkit-appearance: none;
}
.input::-ms-clear {
  display: none;
}
</style>
